<template>
  <div class="row boxes-row">
    <div class="col-lg-4" v-for="client in boxes" :key="client.id">
      <ClientBox :box="client"/>
    </div>
  </div>
</template>

<script>
import ClientBox from "@/components/clients/ClientBox";
export default {
  name: "ClientGrid",
  components: {ClientBox},
  props: ['boxes'],
}
</script>
